import { create } from "zustand";

interface StageHoverStore {
  hoveredStageId: string | null;
  actions: {
    setHoveredStageId: (stageId: string | null) => void;
  };
}

const useStageHoverStore = create<StageHoverStore>((set) => ({
  hoveredStageId: null,
  actions: {
    setHoveredStageId: (stageId: string | null) =>
      set({ hoveredStageId: stageId }),
  },
}));

export const useStageHoverActions = () =>
  useStageHoverStore((state) => state.actions);

export const useHoveredStageId = () =>
  useStageHoverStore((state) => state.hoveredStageId);